/**
 * Compare 2 arrays of objects or Arrays of strings to find items that have been added, removed, or unchanged
 * @param {Array<object> | Array<string>} newItems - The new items to compare
 * @param {Array<object> | Array<string>} existingItems - The existing items to compare
 * @param {string} idField - The field to use for comparison
 * @returns {object} {itemsToAdd, itemsToDelete, unchangedItems}
 */
export default function findAssociativeChanges(newItems, existingItems, idField = "id")  {
    if(!Array.isArray(existingItems) || !Array.isArray(newItems)){
        console.warn(newItems, existingItems)
        throw Error("Trying to compare associative changes, but new and existing items are not both arrays.");
    }

    //Returns the items that are in existingItems but not in newItems
    const itemsToDelete = existingItems.filter(function(existingItem) {
        return !newItems.some(function(newItem) {
            return typeof existingItem == "object" ? existingItem[idField] == newItem[idField] : existingItem == newItem
        });
    });

    //Returns the items that are in newItems but not in existingItems
    const itemsToAdd = newItems.filter(function(newItem) {
        return !existingItems.some(function(existingItem) {
            return typeof existingItem == "object" ? existingItem[idField] == newItem[idField] : existingItem == newItem
        });
    });

    //Returns the items that are in newItems that are also in existingItems
    const unchangedItems = newItems.filter(function(newItem) {
        return existingItems.some(function(existingItem) {
            return typeof existingItem == "object" ? existingItem[idField] == newItem[idField] : existingItem == newItem
        });
    });

    return {itemsToAdd, itemsToDelete, unchangedItems}
}